import { Component, ElementRef, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FilterToolComponent } from '@/app/components/global/filter-tool/filter-tool.component';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { RfiService } from '@/app/services/rfi/rfi.service';
import { AddRfiComponent } from '../contractor/add-rfi/add-rfi.component';
@Component({
  standalone: true,
  imports: [
    MatIcon,
    CommonModule,
    FilterToolComponent,
    MatMenuModule,
    AddRfiComponent,
  ],
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css'],
})
export class ClientComponent implements OnInit {
  activeRowIndex: number | null = null;
  savedRfiData: any = [];
  tableData!: any;
  projectId: any;
  projectIdNew: any;
  projectName: string;
  projectIdentifier: string;
  private subscription: Subscription = new Subscription();
  isDialogOpen: boolean = false;

  constructor(
    private readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly getProjectIdService: GetProjectIdService,
    private readonly elementRef: ElementRef,
    private readonly route: ActivatedRoute,
    private readonly rfiService: RfiService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });

    this.projectId = this.getProjectIdService.getProjectId();
    this.getRfiListing();
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if (!this.projectIdNew) {
        this.projectIdNew = this.getProjectIdService.getProjectId();
      }
      this.getRfiListing();
    });
  }

  getRfiListing(): any {
    return this.rfiService.getClientRfiList().subscribe({
      next: (data: any) => {
        if (data?.meta?.success) {
          this.tableData = data?.data;
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }

  formatDate(dateString: string): string | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }

  openView(rfiId: any) {
    localStorage.setItem('rfi_id', rfiId);
    this.router.navigate(['/client/rfi-view', this.projectId, rfiId], {
      queryParams: {
        projectName: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }

  handleCreateRfi() {
    this.isDialogOpen = !this.isDialogOpen;
  }

  handleDialog() {
    this.isDialogOpen = !this.isDialogOpen;
    this.getRfiListing();
  }

  openDialog() {
    this.isDialogOpen = !this.isDialogOpen;
  }
  loadRfiData() {
    this.getRfiListing();
  }
}
